import {
  AssetsAg,
  AssetsAr,
  AssetsBr,
  AssetsCg,
  AssetsDk,
  AssetsIq,
  AssetsNg,
  AssetsUk,
  AssetTypeOf,
  CountryData,
} from 'types/wellGuardian';

export const getAssetsByCountry = (country: string): AssetTypeOf => {
  switch (country) {
    case CountryData.denmark:
      return AssetsDk;
    case CountryData.nigeria:
      return AssetsNg;
    case CountryData.angola:
      return AssetsAg;
    case CountryData.congo:
      return AssetsCg;
    case CountryData.brazil:
      return AssetsBr;
    case CountryData.iraq:
      return AssetsIq;
    case CountryData.argentina:
      return AssetsAr;
    default:
      return AssetsUk;
  }
};
